import React, { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import Attendances from "../UserDetails/Attendances";
import Leave from "../UserDetails/Leave";
import Dashboardnavbarcopy from "../../layout/Dashboardnavbarcopy";
import { AttendanceDashboard, EmployeeDetailsChangeTimeline, SalaryHistoryTimeline } from "./EmployeeManagementComponents";
import { EmployeeBankDetailsChangeLogs, EmployeeCompensatoryLogTable, EmployeeCompensatoryRequests, EmployeeNotificationLogTable, EmployeeQuickAppraisalTable, StarRankingList } from "./EmployeeManagementTables";
import Performance from "../UserDetails/Performance";

const AttendanceAndSelfRequestManagement = () => {

    const [toggleState, setToggleState] = useState(1);
    const [buffer, setBuffering] = useState(true); //buffering logic

    const emp_code = sessionStorage.getItem("emp_code")
    const email = sessionStorage.getItem("email")
    const profile = false
    const requesttoggleleave = 1
    const requesttoggleod = 2

    const getSelectedTitle = () => {
        switch (toggleState) {
            case 0:
                return 'Attendance Dashboard';
            case 1:
                return 'My Attendance';
            case 2:
                return 'My Leave Requests';
            case 3:
                return 'My Outduty Requests';
            case 4:
                return 'My Compensatory Requests';
            case 5:
                return 'My Leave History';
            default:
                return 'My Attendance';
        }
    };

    return (
        <>
            <Dashboardnavbarcopy name={getSelectedTitle()} url="Attendance & Request Management" />
            <div className="bloc-tabs-with-white-bg subcontent-tabs content-tabs">
                <div className="wfm-marginn  field-cont">
                    <button
                        className={
                            toggleState === 0
                                ? "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-active-tabs"
                                : "dashboardcomponent-tabs  font-weight400  font-size-subheading   white-tab"
                        }
                        onClick={() => { setToggleState(0) }}
                    >
                        Dashboard
                    </button>
                    <button
                        className={
                            toggleState === 1
                                ? "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-active-tabs"
                                : "dashboardcomponent-tabs  font-weight400  font-size-subheading   white-tab"
                        }
                        onClick={() => { setToggleState(1) }}
                    >
                        Attendance
                    </button>

                    <button
                        className={
                            toggleState === 2
                                ? "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-active-tabs"
                                : "dashboardcomponent-tabs  font-weight400  font-size-subheading   white-tab"
                        }
                        onClick={() => { setToggleState(2) }}
                    >
                        Leaves
                    </button>

                    <button
                        className={
                            toggleState === 3
                                ? "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-active-tabs"
                                : "dashboardcomponent-tabs  font-weight400  font-size-subheading   white-tab"
                        }
                        onClick={() => { setToggleState(3) }}
                    >
                        Out Duties
                    </button>

                    <button
                        className={
                            toggleState === 4
                                ? "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-active-tabs"
                                : "dashboardcomponent-tabs  font-weight400  font-size-subheading   white-tab"
                        }
                        onClick={() => { setToggleState(4) }}
                    >
                        Compensatory
                    </button>

                    {/* <button
                        className={
                            toggleState === 5
                                ? "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-active-tabs"
                                : "dashboardcomponent-tabs  font-weight400  font-size-subheading   white-tab"
                        }
                        onClick={() => { setToggleState(5) }}
                    >
                        History Logs
                    </button> */}

                </div>
            </div>

            <div className="content-tabs">

                {toggleState === 0 ? (
                    <AttendanceDashboard email={email} emp_code={emp_code} />
                ) : null}
                {toggleState === 1 ? (
                    <Attendances email={email} emp_code={emp_code} />
                ) : null}
                {toggleState === 2 ? (
                    <Leave requesttoggle={requesttoggleleave} email={email} emp_code={emp_code} />
                ) : null}
                {toggleState === 3 ? (
                    <Leave requesttoggle={requesttoggleod} email={email} emp_code={emp_code} />
                ) : null}
                {toggleState === 4 ? (
                    <EmployeeCompensatoryRequests email={email} emp_code={emp_code} />
                ) : null}
                {toggleState === 5 ? (
                    <EmployeeHistoryTab email={email} emp_code={emp_code} />
                ) : null}



            </div >
            <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
        </>
    );
};

// const EmployeePerformanceTab = ({ emp_code, email }) => {

//     const [toggleState, setToggleState] = useState(1);
//     return (
//         <>
//             <div className="bloc-tabss wfm-marginn">
//                 <button
//                     className={
//                         "leave-tab " +
//                         (toggleState === 1
//                             ? "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-active-tabs "
//                             : "dashboardcomponent-tabs  font-weight400  font-size-subheading   ")
//                     }
//                     onClick={() => setToggleState(1)}
//                 >
//                     Quick Appraisal Ratings
//                 </button>
//                 <button
//                     className={
//                         "leave-tab " +
//                         (toggleState === 2
//                             ? "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-active-tabs "
//                             : "dashboardcomponent-tabs  font-weight400  font-size-subheading   ")
//                     }
//                     onClick={() => setToggleState(2)}
//                 >
//                     Awards
//                 </button>
//             </div>

//             <div className="content-tabs">

//                 {toggleState === 1 ? (
//                     sessionStorage.getItem("company_id") === "beb197dd-9ad1-4136-a1ad-bb469e7127a2" ?
//                         <EmployeeQuickAppraisalTable isHOD={true} emp_code={emp_code} />
//                         :
//                         <EmployeeQuickAppraisalTable isHOD={false} emp_code={emp_code} />
//                 ) : null}
//                 {toggleState === 2 ? (
//                     <Performance email={email} emp_code={emp_code} />
//                 ) : null}
//             </div >
//         </>
//     )
// };

const EmployeePerformanceTab = ({ emp_code, email }) => {
    const location = useLocation();
    const [toggleState, setToggleState] = useState(location.state?.performanceTab ?? 1);

    const tabConfig = [
        { id: 1, label: "Quick Appraisal Ratings" },
        { id: 2, label: "Awards" },
        { id: 3, label: "Star Ranking" }
    ];

    return (
        <>
            <div className="modern-tab-bar" style={{ marginLeft: '0px', marginRight: '0px' }}>
                {tabConfig.map((tab) => (
                    <button
                        key={tab.id}
                        className={`modern-tab-btn ${toggleState === tab.id ? "active" : ""}`}
                        onClick={() => setToggleState(tab.id)}
                    >
                        {tab.label}
                    </button>
                ))}
            </div>

            <div className="content-tabs" style={{ margin: "0px" }}>
                {toggleState === 1 && (
                    sessionStorage.getItem("company_id") === "beb197dd-9ad1-4136-a1ad-bb469e7127a2" ?
                        <EmployeeQuickAppraisalTable isHOD={true} emp_code={emp_code} /> :
                        <EmployeeQuickAppraisalTable isHOD={false} emp_code={emp_code} />
                )}
                {toggleState === 2 && <Performance email={email} emp_code={emp_code} />}
                {toggleState === 3 && (
                    <StarRankingList
                        emp_code={emp_code}
                        initialStart={location.state?.startMonth}
                        initialEnd={location.state?.endMonth}
                    />
                )}
            </div>
        </>
    );
};

const EmployeeHistoryTab = ({ emp_code, email }) => {

    const [toggleState, setToggleState] = useState(1);
    return (
        <>
            <div className="bloc-tabss wfm-marginn">
                {/* <button
                    className={
                        "leave-tab " +
                        (toggleState === 1
                            ? "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-active-tabs "
                            : "dashboardcomponent-tabs  font-weight400  font-size-subheading   ")
                    }
                    onClick={() => setToggleState(1)}
                >
                    Leave Comp Off
                </button> */}
                {/* <button
                    className={
                        "leave-tab " +
                        (toggleState === 2
                            ? "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-active-tabs "
                            : "dashboardcomponent-tabs  font-weight400  font-size-subheading   ")
                    }
                    onClick={() => setToggleState(2)}
                >
                    Notification History
                </button> */}

                {/* Add compensatory part here */}
                <button
                    className={
                        "leave-tab " +
                        (toggleState === 3
                            ? "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-active-tabs "
                            : "dashboardcomponent-tabs  font-weight400  font-size-subheading   ")
                    }
                    onClick={() => setToggleState(3)}
                >
                    Employee History
                </button>
                <button
                    className={
                        "leave-tab " +
                        (toggleState === 4
                            ? "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-active-tabs "
                            : "dashboardcomponent-tabs  font-weight400  font-size-subheading   ")
                    }
                    onClick={() => setToggleState(4)}
                >
                    Salary History
                </button>
            </div>

            <div className="content-tabs">

                {/* {toggleState === 1 ? (
                    <EmployeeCompensatoryLogTable email={email} emp_code={emp_code} />
                ) : null} */}

                {toggleState === 2 ? (
                    <EmployeeNotificationLogTable email={email} emp_code={emp_code} />
                ) : null}

                {toggleState === 3 ? (
                    <EmployeeDetailsChangeTimeline email={email} emp_code={emp_code} />
                ) : null}

                {toggleState === 4 ? (
                    < SalaryHistoryTimeline email={email} emp_code={emp_code} />
                    // <>Salary History Table</>
                ) : null}

            </div >
        </>
    )
};

// const EmployeeDynamicRequestsTab = ({ emp_code, email }) => {

//     const [toggleState, setToggleState] = useState(1);
//     return (
//         <>
//             <div className="bloc-tabss wfm-marginn">
//                 <button
//                     className={
//                         "leave-tab " +
//                         (toggleState === 1
//                             ? "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-active-tabs "
//                             : "dashboardcomponent-tabs  font-weight400  font-size-subheading   ")
//                     }
//                     onClick={() => setToggleState(1)}
//                 >
//                     Bank Details Change History
//                 </button>
//                 <button
//                     className={
//                         "leave-tab " +
//                         (toggleState === 2
//                             ? "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-active-tabs "
//                             : "dashboardcomponent-tabs  font-weight400  font-size-subheading   ")
//                     }
//                     onClick={() => setToggleState(2)}
//                 >
//                     Leave Comp Off
//                 </button>
//             </div>

//             <div className="content-tabs">

//                 {toggleState === 1 ? (
//                     <EmployeeBankDetailsChangeLogs email={email} emp_code={emp_code} />
//                 ) : null}

//                 {toggleState === 2 ? (
//                     <EmployeeCompensatoryLogTable email={email} emp_code={emp_code} />
//                 ) : null}

//             </div >
//         </>
//     )
// };

const EmployeeDynamicRequestsTab = ({ emp_code, email }) => {
    const [toggleState, setToggleState] = useState(1);

    // 1. Define tabs in a clean configuration array
    const tabConfig = [
        { id: 1, label: "Bank Details Change History" },
        { id: 2, label: "Leave Comp Off" }
    ];

    return (
        <>
            {/* 2. Map over the tabs using the modern pill styling */}
            <div className="modern-tab-bar" style={{ margin: '0px' }}>
                {tabConfig.map((tab) => (
                    <button
                        key={tab.id}
                        className={`modern-tab-btn ${toggleState === tab.id ? "active" : ""}`}
                        onClick={() => setToggleState(tab.id)}
                    >
                        {tab.label}
                    </button>
                ))}
            </div>

            {/* 3. Render the content cleanly */}
            <div className="content-tabs" style={{ margin: '0px' }}>
                {toggleState === 1 && (
                    <EmployeeBankDetailsChangeLogs email={email} emp_code={emp_code} />
                )}

                {toggleState === 2 && (
                    <EmployeeCompensatoryLogTable email={email} emp_code={emp_code} />
                )}
            </div>
        </>
    );
};

export {
    AttendanceAndSelfRequestManagement,
    EmployeePerformanceTab,
    EmployeeHistoryTab,
    EmployeeDynamicRequestsTab,
};
